const productUnitLabel = {
  quantity: "تعداد",
  kilogram: "وزن",
  liter: "حجم ",
  milliLiter: "حجم",
  gram: "وزن",
  ton: "وزن",
  cc: "حجم",
  meter: "طول",
  squareMeter: "مساحت",
  cubicMeter: "حجم",
  feet: "طول",
  inche: "طول",
  squareInche: "مساحت",
  squareFeet: "مساحت",
  hour: " زمان",
  minute: " زمان"
}

export default productUnitLabel